import React from 'react'
import { Helmet } from "react-helmet";
import "../../styles/SearchMap.css";
import KH_Image from "../../Images/kh_image_2-1.png";
import kleenhub_logo from "../../Images/plain_logo.png";
import { Button } from '@mui/material';
const webSiteUrl = 'https://kleenhub.com';

export const UserRegistered = () => {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        document.title = 'kleen hub - Registered';  
    }, []);

    const RegistrationSuccess = () => {
        return (
            <div style={{ maxWidth: '420px', position: 'absolute',
            top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                <a className='title' style={{ maxWidth: '420px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                    <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                </a>
                <div className="img1" style={{ position: 'relative', top: '-100px' }} id="first-page">
                    <img alt="KleenHub Logo" height={"100%"} width={"100%"} src={KH_Image}/>
                    <div className='div-text'>
                        <div id="oval_parent" className="multi-ellipse" style={{ top: '-160px', display: 'block' }}>
                            <div id="oval"></div>
                        </div>
                        <div className="vertical-center" style={{ display: 'block', top: '130px' }}>
                            <p className='text-content-left' style={{ position: 'relative', marginTop: '-190px', textAlign: 'center', padding: '0px' }}>
                                Registration completed
                            </p>
                            <Button variant="outlined"
                                style={{ backgroundColor: 'transparent', borderRadius: "50%", left: '20%', top: '10px', lineHeight: '1', width: "160px", height: "68px",
                                fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                                textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                disableRipple={true}
                                // onClick={onButtonClick}
                                >
                                    go to account
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Helmet>
                <title>kleenhub</title>
            </Helmet>
            <div className='upcoming_leagues_background_img'>
                <div className='leagues_details'>
                </div>
            </div>
            {
                RegistrationSuccess()
            }
        </div>
    )
}
